const OfferLineBreakdown = {
  paid_and_free: '{{paidQuantity}} × {{price}} bezahlt · {{freeQuantity}} × gratis',
  all_free: '{{freeQuantity}} × gratis',
};

export default OfferLineBreakdown;
